export default [
  {
    path: '/settings/attendance',
    name: 'attendanceSettings',
    redirect: '/settings/attendance/conselhoSettings',
    component: () => import('@/views/settings/attendance/AttendanceSettings.vue'),
    meta: {
      action: 'ROLE_ATEND_CONSULTAR',
      resource: 'ACL',
      pageTitle: 'Cadastro Atendimentos',
      breadcrumb: [
        {
          text: 'Atendimento',
        },
      ],
    },
    children: [
      {
        path: 'convenioSettings',
        name: 'convenioSettings',
        component: () => import('@/views/settings/attendance/ConvenioSetting.vue'),
        meta: {
          pageTitle: 'Convênios',
          action: 'ROLE_CONVENIO_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Cadastros Módulo Atendimento | Convênios',
            },
          ],
        },
      },
      {
        path: 'conselhoSettings',
        name: 'conselhoSettings',
        component: () => import('@/views/settings/attendance/ConselhoSettings.vue'),
        meta: {
          pageTitle: 'Conselhos',
          action: 'ROLE_CONSELHO_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Cadastros Módulo Atendimento | Conselhos',
            },
          ],
        },
      },
      {
        path: 'especialidadeSettings',
        name: 'especialidadeSettings',
        component: () => import('@/views/settings/attendance/EspecialidadeSetting.vue'),
        meta: {
          pageTitle: 'Especialidades',
          action: 'ROLE_ESPECIALIDADE_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Cadastros Módulo Atendimento | Especialidades',
            },
          ],
        },
      },
      {
        path: 'exameSettings',
        name: 'exameSettings',
        component: () => import('@/views/settings/attendance/ExameSetting.vue'),
        meta: {
          pageTitle: 'Exames',
          action: 'ROLE_EXAME_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Cadastros Módulo Atendimento | Exames',
            },
          ],
        },
      },
      {
        path: 'feriadoSettings',
        name: 'feriadoSettings',
        component: () => import('@/views/settings/attendance/FeriadoSetting.vue'),
        meta: {
          pageTitle: 'Feriados',
          action: 'ROLE_FERIADO_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Cadastros Módulo Atendimento | Feriados',
            },
          ],
        },
      },
      {
        path: 'situacaoAtendimentoSettings',
        name: 'situacaoAtendimentoSettings',
        component: () => import('@/views/settings/attendance/SituacaoAtendimentoSetting.vue'),
        meta: {
          pageTitle: 'Situação Atendimento',
          action: 'ROLE_SITUACAO_ATENDIMENTO_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Cadastros Módulo Atendimento | Situação Atendimento',
            },
          ],
        },
      },
      {
        path: 'statusOdontogramaSettings',
        name: 'statusOdontogramaSettings',
        component: () => import('@/views/settings/attendance/statusOdontogramaSetting.vue'),
        meta: {
          pageTitle: 'Status Odontograma',
          action: 'ROLE_ODONTOGRAMA_STATUS_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Cadastros Módulo Atendimento | Status Odontograma',
            },
          ],
        },
      },
      {
        path: 'tipoAtendimentoSettings',
        name: 'tipoAtendimentoSettings',
        component: () => import('@/views/settings/attendance/TipoAtendimentoSetting.vue'),
        meta: {
          pageTitle: 'Tipos Atendimento',
          action: 'ROLE_TIPO_ATENDIMENTO_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Cadastros Módulo Atendimento | Tipos Atendimento',
            },
          ],
        },
      },
      {
        path: 'unidadeAtendimentoSettings',
        name: 'unidadeAtendimentoSettings',
        component: () => import('@/views/settings/attendance/UnidadeAtendimentoSetting.vue'),
        meta: {
          pageTitle: 'Unidades Atendimento',
          action: 'ROLE_UNIDADE_ATENDIMENTO_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Cadastros Módulo Atendimento | Unidades Atendimento',
            },
          ],
        },
      },
      {
        path: 'profissionalAtendimentoSettings',
        name: 'profissionalAtendimentoSettings',
        component: () => import('@/views/settings/attendance/ProfissionalSetting.vue'),
        meta: {
          pageTitle: 'Profissionais',
          action: 'ROLE_PROFISSIONAL_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Cadastros Módulo Atendimento | Profissionais',
            },
          ],
        },
      },
      {
        path: 'atendimentosettings',
        name: 'atendimentosettings',
        component: () => import('@/views/settings/attendance/ProfissionalSetting.vue'),
        meta: {
          pageTitle: 'Atendimentos',
          action: 'ROLE_ATEND_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Cadastros Módulo Atendimento | Atendimentos',
            },
          ],
        },
      },
      {
        path: 'doencasCidSettings',
        name: 'doencasCidSettings',
        component: () => import('@/views/settings/attendance/DoencasCidSetting.vue'),
        meta: {
          pageTitle: 'Doenças CID',
          action: 'ROLE_DOENCA_CID_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Cadastros Módulo Atendimento | Doenças CID',
            },
          ],
        },
      },
      {
        path: 'parameterAttendance',
        name: 'parameterAttendance',
        component: () => import('@/views/settings/attendance/ParameterSetting.vue'),
        meta: {
          pageTitle: 'Parametros',
          action: 'ROLE_PARAMETRO_ATEND_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Cadastros Módulo Atendimento | Parametros',
            },
          ],
        },
      },
      {
        path: 'camposAdicionaisSettings',
        name: 'camposAdicionaisSettings',
        component: () => import('@/views/settings/attendance/CamposAdicionaisSetting.vue'),
        meta: {
          pageTitle: 'Campos Adicionais',
          action: 'ROLE_CAMPO_ADICIONAL_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Cadastros Módulo Atendimento | Campos Adicionais',
            },
          ],
        },
      },
      {
        path: 'procedimentoSettings',
        name: 'procedimentoSettings',
        component: () => import('@/views/settings/attendance/ProcedimentosSetting.vue'),
        meta: {
          pageTitle: 'Procedimentos',
          action: 'ROLE_PROCEDIMENTO_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Cadastros Módulo Atendimento | Procedimentos',
            },
          ],
        },
      },
      {
        path: 'grupoSettings',
        name: 'grupoSettings',
        component: () => import('@/views/settings/attendance/GruposSettings.vue'),
        meta: {
          pageTitle: 'Grupos',
          action: 'ROLE_GRUPO_PROCEDIMENTO_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Cadastros Módulo Atendimento | Grupos',
            },
          ],
        },
      },
    ],
  },
]
